// eslint-disable-next-line no-restricted-imports
import styled from '@emotion/styled';
import { Flex, SearchIcon, Typography } from '@iheartjane/reefer';

import { useKioskSpacing } from '@jane/kiosk/hooks';

interface NoResultsProps {
  body?: string;
}

const NoResultsWrapper = styled(Flex)(({ theme }) => ({
  backgroundColor: theme.colors.grays.ultralight,
  borderRadius: 24,
}));

export const NoResults = ({ body }: NoResultsProps) => {
  const { defaultSpacing } = useKioskSpacing({
    defaultPadSize: 40,
    defaultSize: 32,
  });

  return (
    <NoResultsWrapper
      alignItems="center"
      flexDirection="column"
      grow={1}
      height="100%"
      justifyContent="center"
      mx={defaultSpacing}
      mb={defaultSpacing}
      p={defaultSpacing}
    >
      <SearchIcon size="xl" />
      <Typography my={32} variant="body-semibold">
        {body || 'No results found. Try another search word.'}
      </Typography>
    </NoResultsWrapper>
  );
};
